import React, { useCallback } from 'react';
import { NuvoMenuItem } from '@nuvolo/nuux-core/components/NuvoMenuItem';
import { useNavigate } from 'react-router-dom';
import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { NuvoText } from '@nuvolo/nuux-core/components/NuvoText';
import { ACTIVE_COLOR, INACTIVE_COLOR } from './Styles';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import MobileActiveMarker from './MobileActiveMarkter';
import FAIcon from '#/common/components/FAIcon';
import Anchor from '#/common/components/Anchor';

export interface MenuItemProps {
  label: string;
  route: string;
  icon: string;
  isActive?: boolean;
  filled?: boolean;
  desktopOnly?: boolean;
  onClick?: () => void;
  shouldShow?: boolean;
  collapsed?: boolean;
}

const activeColor = ACTIVE_COLOR;
const inactiveColor = INACTIVE_COLOR;

const MenuItem: React.FC<MenuItemProps> = (props) => {
  const { label, route, icon, isActive, desktopOnly, onClick, filled = true, collapsed } = props;
  const { isMobile } = useViewport();

  if (isMobile && desktopOnly) {
    return null;
  }

  return (
    <Anchor path={route} onClick={onClick}>
      <NuvoMenuItem
        label={
          <NuvoBox
            style={{ position: 'relative', height: '52px', boxSizing: 'border-box' }}
            display="flex"
            width="100%"
            flexDirection={isMobile ? 'column' : 'row'}
            alignItems="center"
            justifyContent={isMobile ? 'center' : 'flex-start'}
            paddingX={isMobile ? undefined : '16px'}
            gap={isMobile ? '5px' : '12px'}>
            {isMobile && isActive && <MobileActiveMarker />}
            <NuvoBox
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{ flexShrink: 0 }}>
              <FAIcon icon={icon} size="xl" color={isActive ? activeColor : inactiveColor} />
            </NuvoBox>
            <div
              style={{
                overflow: 'hidden',
                maxWidth: !isMobile && collapsed ? 0 : 200,
                opacity: !isMobile && collapsed ? 0 : 1,
                transition: 'max-width 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease',
                whiteSpace: 'nowrap',
                flexShrink: 0,
              }}>
              <NuvoText type="body" color={isActive ? activeColor : inactiveColor}>
                {label}
              </NuvoText>
            </div>
          </NuvoBox>
        }
      />
    </Anchor>
  );
};

export default React.memo(MenuItem);
